/**
 * Map of width presets to CSS classes
 */
export const MODAL_WIDTH_MAP = {
  sm: 'max-w-[360px]',
  md: 'max-w-[500px]',
  lg: 'max-w-[640px]',
  xl: 'max-w-[800px]',
} as const

/**
 * Map of height presets to CSS classes
 */
export const MODAL_HEIGHT_MAP = {
  sm: 'h-[360px]',
  md: 'h-[478px]',
  lg: 'h-[640px]',
  xl: 'h-[800px]',
  full: 'h-[85vh]',
  'max-sm': 'max-h-[360px]',
  'max-md': 'max-h-[478px]',
  'max-lg': 'max-h-[640px]',
  'max-xl': 'max-h-[800px]',
  'max-full': 'max-h-[85vh]',
} as const

export type ModalWidth = keyof typeof MODAL_WIDTH_MAP
export type ModalHeight = keyof typeof MODAL_HEIGHT_MAP

/**
 * Available modal width presets
 */
export const MODAL_WIDTHS = Object.keys(MODAL_WIDTH_MAP) as Array<keyof typeof MODAL_WIDTH_MAP>

/**
 * Available modal height presets (including fixed and max heights)
 */
export const MODAL_HEIGHTS = Object.keys(MODAL_HEIGHT_MAP) as Array<keyof typeof MODAL_HEIGHT_MAP>

/**
 * Fixed height presets (non-scrollable)
 */
export const MODAL_FIXED_HEIGHTS: Array<keyof typeof MODAL_HEIGHT_MAP> = ['sm', 'md', 'lg', 'xl', 'full']

/**
 * Max height presets (scrollable)
 */
export const MODAL_MAX_HEIGHTS: Array<keyof typeof MODAL_HEIGHT_MAP> = ['max-sm', 'max-md', 'max-lg', 'max-xl', 'max-full']

export enum ModalFooterWithActionsType {
  /** Default type with primary CTA. */
  DEFAULT = 'default',
  /** Destructive type with destructive CTA. */
  DESTRUCTIVE = 'destructive',
}
